import { MenuDataLocale } from "../../menudata/types/MenuDataLocale";
import { PaymentType } from "../../../common/payment/paymentType";

export const GUEST_PLATFORM_FEE_TEXT = "me&u platform fee";

export interface ProcessingFeeTextOptions {
    // Server-resolved label, returned verbatim when present so the wording cannot disagree with the
    // rate charged. Nothing supplies it while ProductFees stays out of redux; absent means use the flag.
    feeLabel?: string | null;
    guestPlatformFeeEnabled?: boolean | null;
}

export const getProcessingFeeText = (
    menuDataLocale: MenuDataLocale,
    paymentMethod?: PaymentType | string | null,
    options?: ProcessingFeeTextOptions
) => {
    if (options?.feeLabel) {
        return options.feeLabel;
    }

    if (menuDataLocale.locale === "en-GB") {
        return "Administration fee";
    } else if (menuDataLocale.locale === "en-US") {
        return "Card processing fee";
    }

    // Checked explicitly rather than folded into the default below: that default also serves
    // en-NZ, which stays on the legacy scheme and its legacy wording. Keyed on currency, matching
    // order-hub's scope and the venue-facing apps - a venue can carry AUD without an en-AU locale.
    if (menuDataLocale.currency?.toUpperCase() === "AUD" && options?.guestPlatformFeeEnabled) {
        return GUEST_PLATFORM_FEE_TEXT;
    }

    switch (paymentMethod) {
        case PaymentType.CARD:
        case PaymentType.ADDEDCARD:
        case PaymentType.GROUPTAB:
        case "Card":
        case "AddedCard":
        case "GroupTab":
        case null:
        case undefined:
            return "Card processing fee";
        default:
            return "Payment processing fee";
    }
};
